import React from "react";

export interface LastMonthExpenseInsightItem {
  accentColor: "success" | "warning" | "neutral";
  description: string;
}

export interface LastMonthExpenseInsightsPanelProps {
  monthLabel?: string;
  insights: LastMonthExpenseInsightItem[];
  loading?: boolean;
}

const barClass: Record<
  LastMonthExpenseInsightItem["accentColor"],
  string
> = {
  success: "bg-success-500",
  warning: "bg-warning-500",
  neutral: "bg-neutral-300",
};

export function LastMonthExpenseInsightsPanel({
  monthLabel = "January · Insights",
  insights,
  loading = false,
}: LastMonthExpenseInsightsPanelProps) {
  if (loading) {
    return (
      <div className="flex flex-col items-start gap-4 flex-1 min-w-0">
        <div className="h-4 w-32 animate-pulse rounded bg-neutral-200" />
        {[1, 2].map((i) => (
          <div
            key={i}
            className="flex w-full gap-4 rounded-lg border border-solid border-neutral-100 bg-neutral-50 px-4 py-4 h-14 animate-pulse"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-start gap-4 flex-1 min-w-0">
      <span className="text-caption-bold font-caption-bold text-neutral-400 uppercase tracking-widest">
        {monthLabel}
      </span>
      {insights.map((item, i) => (
        <div
          key={i}
          className="flex w-full gap-4 rounded-lg border border-solid border-neutral-100 bg-neutral-50 px-4 py-4 items-stretch"
        >
          <div
            className={`flex w-1 flex-none flex-col items-start rounded-full ${barClass[item.accentColor]}`}
          />
          <span className="text-body font-body text-neutral-700 flex-1">
            {item.description}
          </span>
        </div>
      ))}
    </div>
  );
}
